import { defineMessages } from 'react-intl';

/**
 * The step and failure copy of a kit asset or reel that works or failed (designs release-kit r2,
 * t3): the Assets cards and the Studio full video stages read it. The ids that only the native
 * Work screen renders are in `src/i18n/nativeMessages.ts`.
 */
export const studioWorkMessages = defineMessages({
  stageQueued: { id: 'app.sml.promote.studio.work.stage.queued', defaultMessage: 'In the queue' },
  stageSong: { id: 'app.sml.promote.studio.work.stage.song', defaultMessage: 'Reading the song' },
  stagePlan: { id: 'app.sml.promote.studio.work.stage.plan', defaultMessage: 'Planning' },
  stageRender: { id: 'app.sml.promote.studio.work.stage.render', defaultMessage: 'Rendering' },
  ready: { id: 'app.sml.promote.studio.work.ready', defaultMessage: 'Ready' },
  readyToReview: { id: 'app.sml.promote.studio.work.readyToReview', defaultMessage: 'Ready to review' },
  failed: { id: 'app.sml.promote.studio.work.failed', defaultMessage: 'Could not make it' },
  queueHint: {
    id: 'app.sml.promote.studio.work.queueHint',
    defaultMessage: 'Videos of one artist render one at a time.',
  },
  openCatalog: { id: 'app.sml.promote.studio.work.openCatalog', defaultMessage: 'Open the catalog' },
  creditBack: { id: 'app.sml.promote.studio.work.creditBack', defaultMessage: 'Credit back' },
  noCredit: { id: 'app.sml.promote.studio.work.noCredit', defaultMessage: 'No credit used' },
  reelName: { id: 'app.sml.promote.studio.work.reelName', defaultMessage: 'AI reel · {seconds} s' },
});
